// Generated with tools/create-component.js
import React from "react";
import "./LoadingSpinner.scss";

interface LoadingSpinnerProps {
  size?: "button" | "md";
}

/**
 * Loading spinner animated component
 *
 * @param size Different sizes for component, default "md"
 * @returns a animating loading spinner
 *
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ size = "md" }) => {
  return <div className={`loading-spinner loading-spinner--${size}`}></div>;
};
